<template>
<v-app>
  <v-container fluid  >
    <v-fade-transition mode="out-in">
      <router-view />
    </v-fade-transition>
    <v-snackbar v-model="snackbar" :color="snackbarColor" right top timeout="2500">{{
      snackbarMessage
    }}</v-snackbar>
  </v-container>
</v-app>
</template>
<style>
@font-face {
  font-family: "Verdana";
  src: local("Verdana"), url(./fonts/VERDANA.TTF) format("truetype");
}

</style>
<script>
import axios from "axios";
import { sync } from "vuex-pathify";
import EventBus, { ACTIONS } from "./util/eventbus";
export default {
  name: "App",

  metaInfo: {
    title: "Universal Tutorials",
    titleTemplate: "Universal Tutorials",
    htmlAttrs: { lang: "en" },
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
    ],
  },
  data: () => ({
    snackbar: false,
    snackbarMessage: "",
    snackbarColor: "red",
    //
  }),
  computed: {
    ...sync("app", ["apiUrl", "slaApi", "beta","isMaintenance"]),
    
  },

  mounted() {
    this.readJson(`./../config.json`);
    EventBus.$on(ACTIONS.SNACKBAR, (message) => {
      this.snackbarMessage = message.message;
      
      if (message.color != undefined)
        this.snackbarColor = message.color;
      else
        this.snackbarColor = "error";
      this.snackbar = true;
    });
  },
  methods: {
    readJson(filePath) {
      const self = this;
      axios
        .get(filePath)
        .then(function(response) {
          var myFile = response.data;
          self.apiUrl = myFile.apiUrl;
          self.slaApi = myFile.slaApi;
          self.beta = myFile.beta;
          self.isMaintenance = myFile.isMaintenance;
          //          self.getMenu();
        })
        .catch(function(err) {
          console.log(err);
        });
    },
  },
};
</script>
